import { AuthEnums } from "models/enums";
import useAPIClientHelper from "./useAPIClientHelper";

function useWintCardService() {
  const { apiClientInstance } = useAPIClientHelper();

  const requestWintCardRegistration = () => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    }).WintCardClient.RequestWintCardRegistration();
  };

  const rejectWintCardRegistration = () => {
    return apiClientInstance(AuthEnums.AuthType.Company).WintCardClient.RejectWintCardRegistration();
  };

  return {
    requestWintCardRegistration,
    rejectWintCardRegistration,
  };
}

export default useWintCardService;
